import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [footerSocial, setFooterSocial] = useState([]);
  const [footerCopyright, setFooterCopyright] = useState([]);
  const [logo, setLogo] = useState([]);
  const [footerAddress, setFooterAddress] = useState([]);
  const [isScrollVisible, setIsScrollVisible] = useState(false); // State for "Scroll to Top" button visibility

  // Fetch logo data
  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/logo`)
      .then((res) => res.json())
      .then((info) => setLogo(info));
  }, []);

  // Fetch footer address
  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/footer-address`)
      .then((res) => res.json())
      .then((info) => setFooterAddress(info));
  }, []);

  // Fetch social links
  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/footer-social`)
      .then((res) => res.json())
      .then((info) => setFooterSocial(info));
  }, []);

  // Fetch copyright
  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/copyrights`)
      .then((res) => res.json())
      .then((info) => setFooterCopyright(info));
  }, []);

  // Handle form submission for subscribers
  const handleSubscriber = (event) => {
    event.preventDefault();
    const subemail = event.target.subemail.value;

    const addItem = { subemail };

    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/add-subscriber`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(addItem),
    })
      .then((res) => res.json())
      .then(() => {
        alert("Subscription request sent successfully!");
      });
  };

  // Show "Scroll to Top" button when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsScrollVisible(true);
      } else {
        setIsScrollVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top functionality
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (


    <>
      <footer id="footer-3" className="pt-100 footer division">
        <div className="container">
          {/* FOOTER CONTENT */}
          <div className="row">
            {/* FOOTER INFO */}
            <div className="col-lg-4">

              {
                footerSocial.map(a=>  <div className="footer-info mb-40">
                  {/* For Retina Ready displays take a image with double the amount of pixels that your image will be 
                  displayed (e.g 350 x 82  pixels) */}
                  {
                    logo.map(l=>  <img src={l.logo} width={175} height={41} alt="footer-logo" /> )
                  }
                
                  {/* Text */}
                  <p className="grey-color mt-25">{a.aboutText}
                  </p>
                  {/* Social Icons */}
                  <div className="footer-socials-links mt-25">
                    <ul className="foo-socials text-center clearfix">
                      <li><a href={a.fblink} className="ico-facebook"><i className="fab fa-facebook-f" /></a></li>
                      <li><a href={a.inslink} className="ico-twitter"><i className="fab fa-instagram" /></a></li>
                      <li><a href={a.youlink} className="ico-google-plus"><i className="fab fa-youtube" /></a></li>
  
                    </ul>
                  </div>
                </div> )
              }

            

            </div>
            {/* FOOTER LINKS */}
            <div className="col-md-3 col-lg-2 col-xl-2 offset-xl-1">
              <div className="footer-links mb-40">
                {/* Title */}
                <h6 className="h6-lg">Quick Link</h6>
                {/* Footer List */}
                <ul className="clearfix grey-color">
                  <li><p><a href="#">Home</a></p></li>
                  <li><p><a href="#">Services</a></p></li>
                  <li><p><a href="#">About</a></p></li>
                  <li><p><a href="#">Pricing</a></p></li>
                  <li><p><a href="#">Blog</a></p></li>
                  <li><p><a href="#">Contact Us</a></p></li>
                </ul>
              </div>
            </div>
            {/* FOOTER LINKS */}
            <div className="col-md-3 col-lg-2">
              <div className="footer-links mb-40">
                {/* Title */}
                {/* <h6 className="h6-lg">Get in Touch</h6> */}
                {/* Footer Links */}
                {/* <ul className="clearfix grey-color">
            <li><p><a href="#">About Us</a></p></li>		
            <li><p><a href="#">Contact Us</a></p></li>	
            <li><p><a href="#">Career</a></p></li>	
            <li><p><a href="#">Advertising</a></p></li>	
          </ul> */}
              </div>
            </div>
            {/* FOOTER NEWSLETTER FORM */}
            <div className="col-md-6 col-lg-4 col-xl-3">
              <div className="footer-form mb-20">
                {/* Title */}
                <h6 className="h6-lg">Subscribe Us:</h6>
                {/* Text */}
                <p className="grey-color mb-20">Stay up to date with our latest news and our new products</p>
                {/* Newsletter Form Input */}
                <form onSubmit={handleSubscriber} className="newsletter-form">
                  <div className="input-group">
                    <input type="email" name="subemail" className="form-control" placeholder="Email Address" required id="s-email" />
                    <span className="input-group-btn">
                      <button type="submit" className="btn primary-color">
                        <i className="far fa-arrow-alt-circle-right" />
                      </button>

                    </span>
                  </div>
                  {/* Newsletter Form Notification */}
                  <label htmlFor="s-email" className="form-notification" />
                </form>
              </div>
            </div>	{/* END FOOTER NEWSLETTER FORM */}
          </div>	  {/* END FOOTER CONTENT */}
          {/* BOTTOM FOOTER */}
          <div className="bottom-footer grey-color">
            <div className="row d-flex align-items-center">
              {/* FOOTER COPYRIGHT */}
              <div className="col-md-6">
                {
                  footerCopyright.map(f => <div className="footer-copyright">
                    <p>© {f.copyrightText}</p>
                  </div>)
                }

              </div>
            </div>  {/* End row */}
          </div>	{/* END BOTTOM FOOTER */}
        </div>	   {/* End container */}
      </footer>

    </>
  );
};

export default Footer;
